{
  "title": "particles",
  "type": "array",
  "uniqueItems": true,
  "items": {
    "title": "particle",
    "type": "object",
    "properties": {
      "id": {
        "description": "The unique identifier for a particle",
        "type": "integer",
        "minimum": 0
      },
      "name": {
        "description": "The name of a particle",
        "type": "string",
        "pattern": "\\S+"
      }
    },
    "required": ["id", "name"],
    "additionalProperties": false
  }
}
